// apps/web/src/features/projects/wizard/teamOptions.ts
import type { Role, User } from '@altyor-kronos/shared-types';

export interface UserOption {
  id: string;
  data: User;
}

/**
 * Whether a user is "recommended" for a bucket, i.e. carries the bucket's role.
 * A `null` filterRole (e.g. managers) means there is no specific role to match.
 */
export function isRecommendedForRole(user: UserOption, filterRole: Role | null): boolean {
  return filterRole !== null && user.data.roles.includes(filterRole);
}

/**
 * Build the option list for a team bucket.
 *
 * Returns ALL users (never disables / hides anyone) sorted so that those
 * carrying `filterRole` come first — surfaced as "recommended" — followed by
 * everyone else. Each group is sorted alphabetically by display name so the
 * caller can drive a MUI Autocomplete `groupBy` on the pre-sorted list.
 */
export function buildTeamOptions(users: UserOption[], filterRole: Role | null): UserOption[] {
  return [...users].sort((a, b) => {
    const ra = isRecommendedForRole(a, filterRole) ? 0 : 1;
    const rb = isRecommendedForRole(b, filterRole) ? 0 : 1;
    if (ra !== rb) return ra - rb;
    return (a.data.displayName ?? '').localeCompare(b.data.displayName ?? '');
  });
}
